import { VendorStats as VendorStatsModule } from "../modules/VendorStats/VendorStats";
const VendorStats = () => {
  return <VendorStatsModule />;
};

export default VendorStats;
